import React, { memo, useCallback, useEffect, useState } from 'react';
import { GoogleMap, HeatmapLayer } from '@react-google-maps/api';
import mapStyles from '../../../json/google-maps.json';
import mapStylesDark from '../../../json/dark-theme-google-maps.json';
import { useTheme, Box } from '@mui/material';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import { CircleProgress } from '../../../components/common/CircleProgress';

interface HeatmapGoogleProps {
  darkModeMap: boolean;
  enableSattelite: boolean;
  heatmapData: google.maps.visualization.WeightedLocation[];
  id?: string;
  loading: boolean;
}

const HeatmapGoogle = (props: HeatmapGoogleProps) => {
  const {
    enableSattelite,
    heatmapData,
    id, loading,
  } = props;

  const theme = useTheme();
  const isLoaded = useSelector((state: RootState) => state.user.mapsLoaded);

  const [maps, setMaps] = useState<google.maps.Map | null>(null);

  const onLoad = useCallback((map: google.maps.Map) => {
    map?.setCenter({
      lat: 37.0902,
      lng: -95.7129,
    });
    map?.setZoom(3);
    setMaps(map);
  }, []);


  const onUnmount = useCallback(() => {
    setMaps(null);
  }, []);

  // Bound on heatmap
  useEffect(() => {
    if (heatmapData.length) {
      const bounds = new google.maps.LatLngBounds();
      heatmapData.forEach((data) => bounds.extend(data.location!));
      maps?.fitBounds(bounds);
    }
  }, [heatmapData, maps]);

  return (isLoaded && !loading
    ? (<GoogleMap
      id={`map-${id}`}
      mapContainerStyle={{
        width: '100%',
        height: '100%',
      }}
      onLoad={onLoad}
      onUnmount={onUnmount}
      zoom={5}
      options={{
        zoomControl: false,
        fullscreenControl: false,
        mapTypeControl: enableSattelite || false,
        streetViewControl: false,
        styles: (theme.palette.mode === 'dark') ? mapStylesDark : mapStyles,
      }}
    >
      <HeatmapLayer
        options={{ radius: 25 }}
        data={heatmapData}
      />
    </GoogleMap>
    )
    : <Box
      height={'612px !important'}
      display={'flex'}
      alignItems={'center'}
      justifyContent={'center'}
    >
      <CircleProgress />
    </Box>
  );
};

export default memo(HeatmapGoogle);
